import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse, IBestPriceRequest, IBestPriceResponse } from "../../Orchestrator/Types/Index";

export async function getBestPrice(
    request: IBestPriceRequest, showLoader?: boolean
): Promise<IApiResponse<IBestPriceResponse>> {

    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.bestPrice}`;

    return await apiRequest<IBestPriceResponse>(endpoint, 'POST', {
        body: JSON.stringify(request),
    }, 'none', undefined, undefined, showLoader);
}
